import { Component, EventEmitter, Inject, input, Input, Output } from '@angular/core';
import { Customer, PostalAddressInterface } from "../../models/customer";
import { ModalService } from "@gea-waldviertler-website/shop-lib";

@Component({
    selector: 'gea-shop-address-selector',
    templateUrl: './address-selector.component.html',
    styleUrls: ['./address-selector.component.scss'],
    standalone: false
})
export class AddressSelectorComponent  {

  @Input() addresses?: Map<number, PostalAddressInterface>
  @Input() addressTypeId?: number
  @Input() currentAddressId?: number

  @Output("selectAddress") selectAddressEvent = new EventEmitter<PostalAddressInterface>()
  @Output("deleteAddress") deleteAddressEvent = new EventEmitter<PostalAddressInterface>()
  @Output("saveAddress") saveAddressEvent = new EventEmitter<PostalAddressInterface>()
  @Output("newAddress") newAddressEvent = new EventEmitter<number>()

  modalService: ModalService
  customer = input.required<Customer>()

  constructor(
    @Inject(ModalService) modalService: ModalService,
  ) {
    this.modalService = modalService
  }

  onSelectAddress(address: PostalAddressInterface) {
    this.selectAddressEvent.emit(address)
  }

  onDeleteAddress(address: PostalAddressInterface) {
    if(this.addresses) {
      this.addresses.delete(address.id)
    }
    
    this.deleteAddressEvent.emit(address)
  }

  onSaveAddress(address: PostalAddressInterface) {
    this.saveAddressEvent.emit(address)
  }
}
